export default {
  setDetails(state, data) {
    state.actionDetails.data = data;
  },
  clearDetails(state) {
    state.actionDetails.data = {};
  },
};
